import { Input, Typography } from "antd"
import React, { useMemo, useState } from "react"

import { AvailableFieldCard } from "./FieldCard.tsx"
import type { FormFieldOption } from "./form-field-requirements.types.ts"

const { Text } = Typography

interface AvailableFieldsPanelProps {
  fields: FormFieldOption[]
  usedFieldKeys: Set<string>
}

export function AvailableFieldsPanel({
  fields,
  usedFieldKeys
}: AvailableFieldsPanelProps) {
  const [search, setSearch] = useState("")

  const visible = useMemo(() => {
    const term = search.trim().toLowerCase()
    if (!term) return fields
    return fields.filter((field) => field.label.toLowerCase().includes(term))
  }, [fields, search])

  return (
    <div className="flex flex-col gap-2" data-testid="available-fields-panel">
      <Text className="font-semibold">Available Fields</Text>
      <Input
        allowClear
        onChange={(e) => setSearch(e.target.value)}
        placeholder="Search fields..."
        value={search}
      />
      <div className="flex flex-col gap-1.5">
        {visible.map((field) => (
          <AvailableFieldCard
            disabled={usedFieldKeys.has(field.key)}
            fieldKey={field.key}
            key={field.key}
            label={field.label}
          />
        ))}
        {visible.length === 0 && (
          <Text className="text-sm" type="secondary">
            No fields match &quot;{search}&quot;.
          </Text>
        )}
      </div>
      <Text className="text-xs" type="secondary">
        Drag fields to the right to add them as requirements.
      </Text>
    </div>
  )
}
